import { useState, useEffect } from 'react';
import {
  FEEDBACK_OPTIONS,
  FEEDBACK_OPTIONS_CA,
} from '../../constants/constants';

const useFeedbackFlow = ({
  isCA,
  isBackroom,
  getLocaleStr,
  initialFeedbackSubmitted,
  submitFeedbackHandler,
}) => {
  const [active, setActive] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedbackListOptions, setFeedbackListOptions] = useState([]);
  const [feedbackReaction, setFeedbackReaction] = useState(null);
  const [isFeedbackSubmitted, setFeedbackSubmitted] = useState(initialFeedbackSubmitted);

  const onRatingChange = (selectedRating) => {
    setRating(selectedRating);
    if (selectedRating > 0) {
      !isBackroom && !isCA && setFeedbackListOptions(FEEDBACK_OPTIONS(getLocaleStr)[selectedRating]);
      !isCA && setFeedbackReaction(getLocaleStr(`feedback_content.${selectedRating}`));
    }
  };

  useEffect(() => {
    if (isCA) {
      setFeedbackListOptions(FEEDBACK_OPTIONS_CA(getLocaleStr));
    }
  }, [isCA]);

  const resetFeedbackData = () => {
    setFeedbackReaction(null);
    setFeedbackListOptions(isCA ? FEEDBACK_OPTIONS_CA(getLocaleStr) : []);
    setShowFeedbackModal(false);
  };

  const onFeedbackSubmit = (starRating, cannedResponses, feedbackText, metFlag = null) => {
    setActive(true);
    submitFeedbackHandler(starRating, cannedResponses, feedbackText, isCA ? metFlag : undefined);
    resetFeedbackData();
    setFeedbackSubmitted(true);
  };

  return {
    active,
    setActive,
    showFeedbackModal,
    setShowFeedbackModal,
    rating,
    feedbackListOptions,
    feedbackReaction,
    isFeedbackSubmitted,
    onRatingChange,
    resetFeedbackData,
    onFeedbackSubmit,
  };
};

export default useFeedbackFlow;
